import React from 'react'

import HistoryExportForm from './ExportForm'
import HistoryExportsList from './ExportsList'

const HistoryExportTab = () => (
    <>
        <HistoryExportForm />
        <HistoryExportsList />
    </>
)

export default HistoryExportTab
